<template>
  <div v-if="display">
    <div v-if="(outOfStock || !stockedInHomeBranch || qtyExceeded) && !shippingCommentApplied">
      <!-- User must agree to shipping terms if item is not stocked in home branch -->
      <div
        class="row alert p-2"
        :class="outOfStock ? 'alert-primary' : 'alert-warning'">
        <!-- Non stocks out of stock -->
        <div
          v-if="nonStockOutOfStock"
          class="col-md-8">
          <span
            class="text-dark">
            <i class="text-danger me-1 fa fa-exclamation-triangle"/>
            <span>This item is&nbsp;</span>
            <span style="font-weight: 900">out of stock and will not be restocked.&nbsp;</span>
            <span>Please remove from cart to proceed.</span>
          </span>
        </div>
        <!-- Not stocked in home branch -->
        <div
          v-else-if="!stockedInHomeBranch"
          class="col-md-8">
          <span class="text-dark">
            <span>This item is </span>
            <span style="font-weight: 900"> not stocked </span>
            <span>in your </span>
            <i class="fa fa-home text-info"/>
            <span> Home Branch. </span>
            To have this item ship from another
            <span> branch </span>
            with an added freight charge, please click the button. Note that this item is subject to being cancelled off the order. Please review the current freight policy.
          </span>
        </div>
        <div
          v-else-if="outOfStock"
          class="col-md-8">
          <!-- Out of stock message -->
          <span
            class="text-dark">
            <span>This item is </span>
            <span style="font-weight: 900"> out of stock </span>
            <span>in your </span>
            <i class="fa fa-home text-info"/>
            <span> Home Branch. </span>
            To have this item ship from another
            <span> branch </span>
            with an added freight charge, please click the button. Note that this item is subject to being cancelled off the order. Please review the current freight policy.
          </span>
        </div>
        <div
          v-else-if="qtyExceeded"
          class="col-md-8">
          <span
            class="text-dark">
            <span>The quantity requested for this item</span>
            <span style="font-weight: 900"> exceeds the availability </span>
            <span>in your </span>
            <i class="fa fa-home text-info"/>
            <span> Home Branch. </span>
            Be advised that if you proceed, the excess quantity will be split onto another order. Please review the current freight policy.
          </span>
        </div>
        <div
          v-if="nonStockOutOfStock"
          class="col-md-4 text-center d-flex align-items-center justify-content-center">
          <button
            class="btn btn-primary btn-sm pre"
            @click="$emit('removeFromCart')">
            <i class="fa fa-trash"/>
            Remove from Cart
          </button>
        </div>
        <div
          v-else
          class="col-md-4 text-center d-flex align-items-center justify-content-center">
          <button
            class="btn btn-primary btn-sm pre"
            @click="applyShippingComment">
            <i class="fa fa-truck"/>
            Ship With Added Freight Charge
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    inject: ['env'],
    props:['product', 'shippingCommentApplied', 'nonStockOutOfStock'],
    data(){
      return{
        shippingComment: "Ship item from another warehouse with added freight charge"
      }
    },
    methods:{
      applyShippingComment(){
        this.product.comment = this.product.comment ? this.product.comment + ' , ' + this.shippingComment : this.shippingComment
        this.$emit('updateProduct')
      },
    },
    computed:{
      homeBranch(){return this.$store.getters.homeBranch},
      stockedInHomeBranch(){
        if(this.product.product_data.eclipse_data){
          // Check to see if actualy inventory qty is available in home branch
          const branchRecord = _.find(this.product.product_data.eclipse_data.branches, {id: this.homeBranch})
          if(branchRecord && parseInt(branchRecord.avail) > 0){
            return true
          }else{
            // Check to see if item is flagged as a stocked item in homebranch
            const branchList = this.product.product_data.stock_branches ? _.compact(this.product.product_data.stock_branches.split(',')) : []
            return _.includes(branchList, this.homeBranch)
          }
        }
      },
      outOfStock(){
        if(this.stockedInHomeBranch){
          const branchRecord = _.find(this.product.product_data.eclipse_data.branches, {id: this.homeBranch})
          if(branchRecord && parseInt(branchRecord.avail) == 0) return true
        }
        return false
      },
      // Cart qty > Home Branch Inventory
      qtyExceeded(){
        if(this.stockedInHomeBranch){
          const branchRecord = _.find(this.product.product_data.eclipse_data.branches, {id: this.homeBranch})
          if(branchRecord && parseInt(branchRecord.avail)){
            return this.product.quantity > parseInt(branchRecord.avail)
          }
          return false
        }
        return false
      },
      sessionCompany(){return this.$store.getters.sessionCompany},
      display(){
        if(this.env.includes('EJW')){
          return this.sessionCompany == 'EJ Welch'
        }
      }
    }
  }
</script>

<style scoped>
  .pre{
    white-space: pre-wrap;
    word-break: keep-all;
  }
</style>